import './ChartContainer.scss';
import cn from 'classnames';
import { ReactNode } from 'react';
import { InfoTooltip } from '../InfoTooltip';
import { Spinner } from '../Spinner';
import { ChartContainerFooter } from './ChartContainerFooter';

interface ChartContainerProps {
  title?: string | ReactNode;
  titleAfterDashText?: string;
  leftActions?: ReactNode;
  rightActions?: ReactNode;
  subHeader?: ReactNode;
  tooltipText?: string;
  beforeTooltipText?: string;
  rightSideText?: string;
  footerContent?: string | string[] | ReactNode;
  viewRightActions?: boolean;
  className?: string;
  minHeight?: number;
  isLoading?: boolean;
  children?: ReactNode;
}

export const ChartContainer = ({
  title,
  titleAfterDashText,
  leftActions,
  rightActions,
  subHeader,
  tooltipText,
  beforeTooltipText,
  children,
  rightSideText,
  footerContent,
  viewRightActions = false,
  className,
  minHeight,
  isLoading = false
}: ChartContainerProps) => (
  <div className={cn('chart-container', className)}>
    <div className='header'>
      <div className='main-header'>
        {(title || leftActions) && (
          <div className='left-side'>
            {title && (
              <div className='header-title'>
                {title}
                {titleAfterDashText && <div className='header-title-dash' />}
                {titleAfterDashText && (
                  <span className='header-title-date-range'>{titleAfterDashText}</span>
                )}
              </div>
            )}
            {leftActions && <div className='left-actions'>{leftActions}</div>}
          </div>
        )}
        <div className={cn('right-side', { hidden: !viewRightActions })}>{rightActions}</div>
      </div>
      {subHeader && <div className='sub-header'>{subHeader}</div>}
    </div>
    {(tooltipText || beforeTooltipText || rightSideText) && (
      <div className='tooltip-text-container'>
        {tooltipText && beforeTooltipText && (
          <div className='left-side-tooltip'>
            <div>{beforeTooltipText}</div>
            <InfoTooltip>{tooltipText}</InfoTooltip>
          </div>
        )}
        {!tooltipText && beforeTooltipText && (
          <div className='left-side-tooltip'>{beforeTooltipText}</div>
        )}
        {rightSideText && <div className='right-side-tooltip'>{rightSideText}</div>}
      </div>
    )}
    <div className='contents' style={{ minHeight: minHeight ? `${minHeight}px` : undefined }}>
      {isLoading ? (
        <div className='loading'>
          <Spinner size={50} />
        </div>
      ) : (
        children
      )}
    </div>
    {(Array.isArray(footerContent) ? footerContent.length > 0 : footerContent) && (
      <ChartContainerFooter content={footerContent} />
    )}
  </div>
);
